<i18n>
{
  "fr": {
    "close": "Fermer"
  },
  "de": {

  }
}
</i18n>

<template>
  <md-dialog :md-active="show" v-on:md-clicked-outside="onClose" class="about-dialog">
    <md-dialog-title>Le champ de recherche permet d’atteindre les informations suivantes</md-dialog-title>

    <md-dialog-content>
      <h3>Recherche sur un point d’eau</h3>
      <p>La recherche d’un point d’eau peut se faire par son nom usuel (p.ex. 03M57), son identifiant cantonal ou REGIS ID (p.ex. 26031123-10.138) ou par ses coordonnées (cf. recherche par coordonnées). La recherche s’effectue en mode Plein texte. La sélection du ou d’un des résultats de la recherche permet de recentrer la carte sur le point d’eau concerné.</p>
      <p>
        La recherche peut s’effectuer en utilisant le caractère * comme caractère générique. Par exemple la requête P1*
        renverra les valeurs suivantes : P14, P117 alors que la requête P1 renverra uniquement
        la valeur : P1. En cas d’occurrences multiples, le nom du point d’eau sera complété par le nom de la commune sur
        laquelle il est implanté. Par ex. pour la valeur P1, la requête renverra les valeurs suivantes :<br>
      <ul>
        <li>P1 - Saillon</li>
        <li>P1 - Turtamnn-Unterems</li>
        <li>P1 - Salgesch</li>
        <li>Etc.</li>
      </ul>
      </p>
      <h3>Centrer sur un point de coordonnées</h3>
      <p>
        La recherche géographique permet de centrer automatiquement la carte sur une zone d’intérêt représentée par un couple de coordonnées. Les coordonnées doivent être fournies dans le système de référence CH1903+ / LV95. La saisie des coordonnées peut se faire selon un des formats suivants :<br>
        <ul>
          <li>2600'000 1200'000</li>
          <li>2600000 1200000</li>
          <li>2600000/1200000</li>
          <li>2600000 / 1200000</li>
          <li>2600000,1200000</li>
          <li>2600000 1200000</li>
          <li>1200000 2600000</li>
        </ul>
      </p>

      <h3>Centrer sur une commune</h3>
      <p>La recherche d’une commune peut se faire sur toute ou partie de son nom (p.ex. Visp). La recherche s’effectue en mode Plein texte. Toutes les occurrences de la chaîne de caractères saisie sont retournées. La sélection du ou d’un des résultats de la recherche permet de recentrer la carte sur l’emprise de la commune concernée.</p>

      <h3>Centrer sur une parcelle</h3>
      <p>
        La recherche d’une parcelle se fait en utilisant le couple d’information [n° parcelle + commune] (p.ex. 14236 Sion). La saisie des informations pour la recherche peut se faire selon un des formats suivants :<br>
        <ul>
          <li>1123 Albinen</li>
          <li>Albinen 1123</li>
        </ul>
        La sélection du résultat de la recherche permet de recentrer la carte sur l’emprise de la parcelle concernée.
      </p>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="onClose()">{{ $t('close') }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>

export default {
  name: 'AboutPopup',
  props: {
    show: {
      type: Boolean,
      default: () => { return false }
    }
  },
  methods: {
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
</style>
